export class BxComponentAction {
    constructor(options = {}) {
        this.form = options.form;
    }

    async send() {
        return new Promise(((resolve, reject) => {
            if (!this.form) {
                reject();
                return;
            }

            const component = this.form.getAttribute('data-component');
            const action = this.form.getAttribute('data-action');

            if (!component || !action) {
                reject();
                return;
            }

            const data = new FormData(this.form);

            BX.ajax.runComponentAction(component, action, {
                mode: 'class',
                data,
            }).then((response) => {
                resolve({
                    jsonResponse: response.data,
                });
            }, (response) => {
                resolve({
                    jsonResponse: {
                        isSuccess: false,
                        errorsHtml: response.errors[0]?.message,
                    }
                });
            });
        }));
    }
}